import {
  Cell,
  EnumVariableDefinition,
  MultiselectVariableDefinition,
  VariableCell,
  VariableDefinition,
} from '@/explore/types';

import { isVariableCell } from '.';

export const ensureUniqueVariableKey = (cell: VariableCell, cells: Cell[]): VariableCell => ({
  ...cell,
  definition: {
    ...cell.definition,
    key: generateUniqueVariableKey(
      cell.definition.key,
      cells.filter(isVariableCell).map((i) => i.definition.key),
    ),
  },
});

const updateVariableKey = (input: string): string => {
  const match = input.match(/(\d+)$/);

  if (match !== null) {
    return input.slice(0, match.index) + (parseInt(match[1], 10) + 1);
  }

  return `${input} 2`;
};

export const generateUniqueVariableKey = (input: string, keys: string[]): string => {
  let result = input;

  while (keys.includes(result)) {
    result = updateVariableKey(result);
  }

  return result;
};

export type VariableValueType = 'String' | 'Number' | 'Date' | 'Boolean' | 'Array' | 'DateRange';

export function setVariableCellDefinition(
  cell: VariableCell,
  definition: VariableDefinition,
): VariableCell {
  return { ...cell, definition };
}

type VariableCellWithQueryOptions = VariableCell & {
  definition: (EnumVariableDefinition | MultiselectVariableDefinition) & { source: 'query' };
};

export const isVariableCellWithQueryOptions = (cell: Cell): cell is VariableCellWithQueryOptions =>
  isVariableCell(cell) &&
  (cell.definition.kind === 'enum' || cell.definition.kind === 'multiselect') &&
  cell.definition.source === 'query';
